import React from 'react';
import { TradeAlert } from 'store/services/tradeAlerts/tradeAlertsApi';
import { AlertCardTile } from './AlertCardTile';
import { RequesterProfileBlock } from './RequesterProfileBlock';

interface AlertCardProps {
  alert: TradeAlert;
  /** Which tab the card is being shown in — controls the dismiss vs restore icon. */
  variant: 'all' | 'hidden';
  onSend: (alert: TradeAlert) => void;
  onHide: (alert: TradeAlert) => void;
  onUnhide: (alert: TradeAlert) => void;
}

/**
 * "By card" view: a standalone alert card — the card tile with the requester identity
 * block rendered below it. In "By trader" view the page renders AlertTradeGroup instead,
 * which reuses AlertCardTile + RequesterProfileBlock with the profile deduped to a header.
 */
export const AlertCard: React.FC<AlertCardProps> = ({ alert, variant, onSend, onHide, onUnhide }) => (
  <AlertCardTile
    alert={alert}
    variant={variant}
    onSend={onSend}
    onHide={onHide}
    onUnhide={onUnhide}
    profile={<RequesterProfileBlock requester={alert.requester} />}
  />
);

export default AlertCard;
